exports = module.exports = require("../../../_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ve-draggable-line-horizontal{position:absolute;width:4px;height:100%;background-color:transparent;cursor:col-resize}.ve-draggable-line-vertical{position:absolute;width:100%;height:4px;background-color:transparent;cursor:row-resize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./~/_@ali_ve-draggable-line@2.0.0@@ali/ve-draggable-line/build/style.less
// module id = 240
// module chunks = 0